"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerProptypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var ContainerProptypes = {
  PropTypes: {
    children: _propTypes.default.node,
    width: _propTypes.default.string,
    height: _propTypes.default.string,
    header: _propTypes.default.string,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    margin: _propTypes.default.arrayOf(_propTypes.default.oneOf(_constant.ARR_SPACING_TYPES)),
    focusEffect: _propTypes.default.bool,
    hoverEffect: _propTypes.default.bool,
    isSideBySide: _propTypes.default.bool,
    layout: _propTypes.default.number,
    alignChildren: _propTypes.default.oneOf(_constant2.CHILD_ALIGNMENT),
    gapChildren: _propTypes.default.oneOf(_constant.ARR_SPACING_TYPES),
    hasBoxShadow: _propTypes.default.bool,
    hasBorder: _propTypes.default.bool,
    borderColor: _propTypes.default.oneOf(_constant.ARR_COLORS)
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    focusEffect: false,
    hoverEffect: false,
    isSideBySide: false,
    layout: 2,
    alignChildren: 'start',
    gapChildren: 'none',
    hasBoxShadow: true,
    hasBorder: false
  }
};
exports.ContainerProptypes = ContainerProptypes;